import { render, staticRenderFns } from "./headerBar.vue?vue&type=template&id=45ded9ca"
import script from "./headerBar.vue?vue&type=script&lang=js"
export * from "./headerBar.vue?vue&type=script&lang=js"
import style0 from "./headerBar.vue?vue&type=style&index=0&id=45ded9ca&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports